module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold.07e6a6cd.ttf";